import React from "react";
import { Link } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const categories = [
  {
    id: "hindustani",
    title: "Indian Hindustani Classical Vocals Certification",
    description:
      "Rāga-centric certification in Hindustani classical vocal studies, structured across six progressive levels.",
  },
  {
    id: "indian-contemporary",
    title: "Indian Light Contemporary Film Vocal Performance Certification",
    description:
      "Technique- and performance-based certification for Indian film and light contemporary vocal styles.",
  },
  {
    id: "western-classical",
    title: "Western Classical & Operatic Vocal Performance Certification",
    description:
      "Formal Western classical and operatic voice training with integrated theory and practical assessment.",
  },
  {
    id: "english-contemporary",
    title: "English Contemporary Vocal Performance Certification",
    description:
      "Contemporary English vocal performance, focusing on pop, rock, R&B and related styles.",
  },
];

const levels = [1, 2, 3, 4, 5, 6];

export default function VocalsSyllabusOverview() {
  return (
    <div className="space-y-10">
      <section className="space-y-3 text-center">
        <h1 className="text-2xl font-semibold tracking-tight text-[#182033]">
          Vocal certifications  specialisations & levels
        </h1>
        <p className="mx-auto max-w-3xl text-sm leading-relaxed text-[#4b4a46] sm:text-base">
          Vocal study at Global Music Conservatory is offered through four distinct
          certification routes. Each route comprises six levels, with detailed
          syllabi for practical and theory components.
        </p>
      </section>

      <section className="space-y-8">
        {categories.map((category) => (
          <div
            key={category.id}
            className="space-y-4 rounded-3xl border border-[#ddcaa4] bg-[#f9f2e6] p-4 shadow-sm lg:p-6"
          >
            <div className="space-y-1">
              <h2 className="text-lg font-semibold tracking-tight text-[#182033]">
                {category.title}
              </h2>
              <p className="max-w-3xl text-sm leading-relaxed text-[#4b4a46]">
                {category.description}
              </p>
            </div>

            <div className="overflow-x-auto rounded-2xl border border-[#e1d2b3] bg-[#fdf8ef]">
              <Table>
                <TableHeader className="bg-[#f5ebd9]">
                  <TableRow>
                    <TableHead className="w-[80px] text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                      Level
                    </TableHead>
                    <TableHead className="text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                      Descriptor
                    </TableHead>
                    <TableHead className="w-[160px] text-right text-xs font-semibold uppercase tracking-[0.16em] text-[#1f2738]">
                      Action
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {levels.map((levelNumber) => (
                    <TableRow key={levelNumber} className="text-sm text-[#4b4a46]">
                      <TableCell className="align-top font-semibold text-[#182033]">
                        Level {levelNumber}
                      </TableCell>
                      <TableCell className="align-top">
                        Certification Level {levelNumber}
                      </TableCell>
                      <TableCell className="align-top text-right">
                        <Link
                          to={`/vocals-syllabus/${category.id}/level/${levelNumber}`}
                          className="inline-flex h-8 items-center justify-center rounded-full border border-[#d5c39d] bg-white px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#1f2738] hover:bg-[#f5ebd9]"
                        >
                          View syllabus
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
